"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LoginForm = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _axios = _interopRequireDefault(require("axios"));

var _Auth = require("../../../redux/actions/Auth");

var _reactRouterDom = require("react-router-dom");

var _framerMotion = require("framer-motion");

var _config = _interopRequireDefault(require("../../../config.json"));

var _errorPage = _interopRequireDefault(require("./../../error-views/errorPage"));

var status = null;

var LoginForm = function LoginForm(props) {
  var history = (0, _reactRouterDom.useHistory)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var user = null;
  var loading = props.loading,
      showMessage = props.showMessage,
      message = props.message;

  var onLogin = function onLogin(values) {
    var user = +values.username;
    var password = values.password.toLowerCase();
    var obj = {
      username: user,
      password: password
    };
    var url = _config.default.login;

    _axios.default.post(url, obj).then(function (response) {
      if (response.data.status === "error") setapiError(response.data);
      var authTKn = 'Bearer ' + response.data.token;
      var user = response.data;

      if (user === 'Not Found') {
        history.push('/clPortal/auth/login');
        status = 'Please Enter Correct Username or Password';
      } else {
        localStorage.setItem('CL', user.CL_code);
        localStorage.setItem('token', authTKn);
        history.push('/clPortal/app/home');
      }
    }, function (error) {
      setapiError(error.response);
    });
  };

  (0, _react.useEffect)(function () {
    if (user) {
      history.push('/app/home');
    }
  });
  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_framerMotion.motion.div, {
    initial: {
      opacity: 0,
      marginBottom: 0
    },
    animate: {
      opacity: showMessage ? 1 : 0,
      marginBottom: showMessage ? 20 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    type: "error",
    showIcon: true,
    message: message
  })), status ? /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: status,
    type: "error",
    showIcon: true
  }) : null, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    layout: "vertical",
    name: "login-form",
    onFinish: onLogin
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "username",
    label: "Name",
    rules: [{
      required: true,
      message: 'Please input your username'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    prefix: /*#__PURE__*/_react.default.createElement(_icons.UserOutlined, {
      className: "text-primary"
    })
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "password",
    label: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Password")),
    rules: [{
      required: true,
      message: 'Please input your password'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input.Password, {
    prefix: /*#__PURE__*/_react.default.createElement(_icons.LockOutlined, {
      className: "text-primary"
    })
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    htmlType: "submit",
    block: true,
    loading: loading
  }, "Sign In"))));
};

exports.LoginForm = LoginForm;
LoginForm.defaultProps = {
  otherSignIn: true,
  showForgetPassword: false
};

var mapStateToProps = function mapStateToProps(_ref) {
  var auth = _ref.auth;
  var loading = auth.loading,
      message = auth.message,
      showMessage = auth.showMessage,
      token = auth.token,
      redirect = auth.redirect;
  return {
    loading: loading,
    message: message,
    showMessage: showMessage,
    token: token,
    redirect: redirect
  };
};

var mapDispatchToProps = {
  showAuthMessage: _Auth.showAuthMessage,
  showLoading: _Auth.showLoading,
  hideAuthMessage: _Auth.hideAuthMessage,
  authenticated: _Auth.authenticated
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginForm);

exports.default = _default;